// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgOpenModalIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M21 5v14c0 1.1-.9 2-2 2h-7c-.55 0-1-.45-1-1s.45-1 1-1h7V5H5v7c0 .55-.45 1-1 1s-1-.45-1-1V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2m-7 10c0 .55.45 1 1 1s1-.45 1-1V9c0-.13-.03-.26-.08-.38-.1-.25-.3-.44-.54-.54A1 1 0 0 0 15 8H9c-.55 0-1 .45-1 1s.45 1 1 1h3.59l-9.3 9.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29L14 11.41z" />
  </g>
);
export default SvgOpenModalIcon;
SvgOpenModalIcon.displayName = 'SvgOpenModalIcon';
